exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span[data-v-4a39bfb2]{line-height:22px}#quotation-container[data-v-4a39bfb2]{position:relative}#quotation-container .bg[data-v-4a39bfb2]{position:absolute;top:-10%;left:-20%;display:none}#quotation-inner-cont[data-v-4a39bfb2]{position:relative;z-index:200}@media (max-width:768px){#quotation-container .bg[data-v-4a39bfb2]{display:block}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4a39bfb2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/CertificateDefault.vue
// module id = 9ZVN
// module chunks = 1